export const galleryImages = [
  {
    url: "/images/devanture.jpeg",
    title: "K&O PHONELAB Villeurbanne",
    description: "Notre magasin au 5 Rue Paul Verlaine - Arrêt Tram T6 Gratte-Ciel"
  },
  {
    url: "/images/comptoir-iphones.jpeg",
    title: "Expertise iPhone",
    description: "Réparation et diagnostic de tous modèles d'iPhone"
  },
  {
    url: "/images/reparation-zflip4.jpeg",
    title: "Réparation Samsung Z Flip 4",
    description: "Remplacement d'écran original - Expertise Samsung"
  },
  {
    url: "/images/reparation-pc.jpeg",
    title: "Réparation charnière PC",
    description: "Avant/En cours/Après - Réparation professionnelle d'ordinateurs"
  },
  {
    url: "/images/nintendo-switch.jpeg",
    title: "Réparation Nintendo Switch",
    description: "Expertise consoles de jeux - Nintendo, PlayStation, Xbox"
  },
  {
    url: "/images/microscope-pro.jpeg",
    title: "Équipement professionnel",
    description: "Microscope de précision pour micro-soudure et réparations avancées"
  },
  {
    url: "/images/micro-soudure.jpeg",
    title: "Micro-soudure professionnelle",
    description: "Réparation de carte mère Samsung S22 Ultra - Expertise technique avancée"
  },
  {
    url: "/images/test-faceid.jpeg",
    title: "Tests et diagnostics",
    description: "Test Face ID et diagnostic complet de votre appareil"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_tech-fix-shop/artifacts/wwwlxbpu_IMG_2018.jpeg",
    title: "Réparation fiable et rapide",
    description: "Expert en réparation de téléphones - Service professionnel et pas hors de prix"
  }
];
